/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewDataRpc
 */

export const getPaymentMethodsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewDataRpc',
  rpcName: 'getPaymentMethods',
  auth: 'external',
  fingerprint: 's0CMaxJ_mBxVJfn9TZGDprYD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCurrentSubscriptionsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewDataRpc',
  rpcName: 'getCurrentSubscriptions',
  auth: 'external',
  fingerprint: 's0CMaxJ_mBxmMMyaoka-W7YD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInactiveSubscriptionsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewDataRpc',
  rpcName: 'getInactiveSubscriptions',
  auth: 'external',
  fingerprint: 's0CMaxJ_mBxmMMyaoka-W7YD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInvoicesRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewDataRpc',
  rpcName: 'getInvoices',
  auth: 'external',
  fingerprint: 's0CMaxJ_mBwGd3CqjHcMLrYD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCommercePaymentsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewDataRpc',
  rpcName: 'getCommercePayments',
  auth: 'external',
  fingerprint: 's0CMaxJ_mBzIwQOYA0p5z7YD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};